import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../hooks/useAuth';
import ShoppingTable from './mat-table-shopping';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import { Button } from '@mui/material';


function ShoppingList() {
    const { authData, authDataLang } = useAuth();
  
  return (
    <React.Fragment>
      <div style={{minHeight: 1000}} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
        <Link to="/"><HomeIcon /></Link>
        <CssBaseline />
        <Paper square sx={{ maxHeight: 1000, overflow: 'auto' }}>
            <Typography variant="h5" gutterBottom component="div" sx={{ p: 2, pb: 0 }}>
                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                    <h2 style={{fontFamily: 'b_mitra'}}>
                        سفارشات:
                    </h2>
                    <div style={{textAlign: 'left'}}>
                        <Button  variant="contained" color="secondary"
                        sx={{fontFamily: 'b_mitra', fontSize: 24}}
                        >پرداخت</Button>
                    </div>

                </div>
            </Typography>
            {authData &&
                <div >
                    <ShoppingTable />
                </div>
            }
        </Paper>
      </div>
    </React.Fragment>
  );
}

export default ShoppingList;
